import { QueryStatus } from '@reduxjs/toolkit/query'
import { Group, GroupItem } from '../../../typings'
import { RootState as QueryRootState } from '../services/groupApi'

export interface PreloadOptions {
  pool?: GroupItem
  listCreator?: Group
  listContributor?: Group
}

export const getPreloadedQueryState = ({ pool }: PreloadOptions = {}) => {
  const groupId = pool?.id
  if (!groupId) {
    return {}
  }

  const preloadedQueryState: Partial<QueryRootState> = {
    queries: {
      /* MUST use double quotes to work */
      [`getGroupDetail("${groupId}")`]: {
        data: {
          customer: {
            moneyPools: {
              moneyPool: pool,
            },
          },
        },
        status: QueryStatus.fulfilled,
        endpointName: 'getGroupDetail',
        error: undefined,
        originalArgs: groupId,
        requestId: groupId,
        startedTimeStamp: Date.now(),
        fulfilledTimeStamp: Date.now(),
      },
    },
    mutations: {}, // Add mutations if needed
    subscriptions: {}, // Add subscriptions if needed
  }

  return preloadedQueryState
}
